var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasTeam
    ? _c("div", { staticClass: "md-layout" }, [
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
          },
          [
            _c("div", { staticClass: "custom-toolbar" }, [
              _c(
                "div",
                { staticClass: "custom-toolbar-start" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "Team Settings",
                        },
                      },
                    },
                    [
                      _c("h3", { staticClass: "title" }, [
                        _vm._v("Team Settings"),
                      ]),
                    ]
                  ),
                  _c("h3", { staticClass: "title" }, [
                    _vm._v("   >    " + _vm._s(_vm.$t("menus.setting.apps"))),
                  ]),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-100" },
          [
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  { staticClass: "md-card-header-icon md-card-header-blue" },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [_c("md-icon", [_vm._v("apps")])],
                      1
                    ),
                  ]
                ),
                _c("md-card-content", [
                  _c(
                    "div",
                    { staticClass: "cf-container" },
                    [
                      _c(
                        "div",
                        { staticClass: "cf-action-container" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary md-just-icon md-round",
                              attrs: { title: "Add App" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCreateAppModal()
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("add")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "md-table",
                        { staticClass: "custom-paginated-table" },
                        [
                          _c(
                            "md-table-row",
                            [
                              _c("md-table-head", [_vm._v("Name")]),
                              _c("md-table-head", [_vm._v("Client Id")]),
                              _c("md-table-head", [_vm._v("Client Secret")]),
                              _c("md-table-head", [_vm._v("Customer")]),
                              _c("md-table-head", [_vm._v("Actions")]),
                            ],
                            1
                          ),
                          _vm._l(_vm.appList, function (app) {
                            return _c(
                              "md-table-row",
                              { key: app.appId, attrs: { value: app.appName } },
                              [
                                _c("md-table-cell", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(app.appName) +
                                      "\n                            "
                                  ),
                                ]),
                                _c("md-table-cell", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(app.clientId) +
                                      "\n                            "
                                  ),
                                ]),
                                _c("md-table-cell", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(app.clientSecret) +
                                      "\n                            "
                                  ),
                                ]),
                                _c(
                                  "md-table-cell",
                                  [
                                    _c("span", [_vm._v(_vm._s(app.customer))]),
                                    app.customer
                                      ? _c(
                                          "md-tooltip",
                                          { attrs: { "md-direction": "top" } },
                                          [
                                            _vm._v(
                                              "\n                                    API calls will be restricted to data for this customer only\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "md-table-cell",
                                  { staticClass: "action-buttons" },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-info md-just-icon md-round",
                                        attrs: { title: "Edit Name" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.beginEdit(app)
                                          },
                                        },
                                      },
                                      [_c("md-icon", [_vm._v("edit")])],
                                      1
                                    ),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-success md-just-icon md-round",
                                        attrs: { title: "Regenerate Secret" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.regenerateKey(app)
                                          },
                                        },
                                      },
                                      [_c("md-icon", [_vm._v("refresh")])],
                                      1
                                    ),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-danger md-just-icon md-round",
                                        attrs: { title: "Delete App" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteApp(app)
                                          },
                                        },
                                      },
                                      [_c("md-icon", [_vm._v("delete")])],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }